// AUTO-GENERATED: per-service testimonial pool (3 each).
// Edit freely — used by ServiceTestimonials.tsx on each SEO service page.
export interface ServiceTestimonial {
  name: string;
  location: string;
  rating: number;
  treatment: string;
  review: string;
}

const TESTIMONIALS: Record<string, ServiceTestimonial[]> = {
  "general-dentistry-kalyan": [
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "General check-up",
      "review": "Honestly the best general check-up I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "General check-up",
      "review": "Came in for general check-up after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "General check-up",
      "review": "Dr. Mutha and team are genuinely the best general check-up option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "cosmetic-dentistry-kalyan": [
    {
      "name": "Amit Patil",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Cosmetic consult",
      "review": "Honestly the best cosmetic consult I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Anjali Nair",
      "location": "Diva",
      "rating": 5,
      "treatment": "Cosmetic consult",
      "review": "Came in for cosmetic consult after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Diva."
    },
    {
      "name": "Sandeep Gupta",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Cosmetic consult",
      "review": "Dr. Mutha and team are genuinely the best cosmetic consult option near Thakurli. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "restorative-dentistry-kalyan": [
    {
      "name": "Arjun Rao",
      "location": "Dombivli East",
      "rating": 5,
      "treatment": "Restorative work",
      "review": "Honestly the best restorative work I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Rahul Mehta",
      "location": "Dombivli",
      "rating": 5,
      "treatment": "Restorative work",
      "review": "Came in for restorative work after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Dombivli."
    },
    {
      "name": "Kavita Iyer",
      "location": "Ulhasnagar",
      "rating": 5,
      "treatment": "Restorative work",
      "review": "Dr. Mutha and team are genuinely the best restorative work option near Ulhasnagar. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "orthodontics-kalyan": [
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Orthodontic treatment",
      "review": "Honestly the best orthodontic treatment I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Orthodontic treatment",
      "review": "Came in for orthodontic treatment after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Orthodontic treatment",
      "review": "Dr. Mutha and team are genuinely the best orthodontic treatment option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "best-dentist-in-kalyan": [
    {
      "name": "Anjali Nair",
      "location": "Diva",
      "rating": 5,
      "treatment": "Comprehensive care",
      "review": "Honestly the best comprehensive care I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Sandeep Gupta",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Comprehensive care",
      "review": "Came in for comprehensive care after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Thakurli."
    },
    {
      "name": "Amit Patil",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Comprehensive care",
      "review": "Dr. Mutha and team are genuinely the best comprehensive care option near Khadakpada. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "family-dentist-kalyan": [
    {
      "name": "Vikram Joshi",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Family dental care",
      "review": "Honestly the best family dental care I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Meera Bhatia",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Family dental care",
      "review": "Came in for family dental care after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Khadakpada."
    },
    {
      "name": "Priya Sharma",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Family dental care",
      "review": "Dr. Mutha and team are genuinely the best family dental care option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dental-checkup-cleaning-kalyan": [
    {
      "name": "Suresh Pawar",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Cleaning & polish",
      "review": "Honestly the best cleaning & polish I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Divya Menon",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Cleaning & polish",
      "review": "Came in for cleaning & polish after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Ambernath."
    },
    {
      "name": "Neha Desai",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Cleaning & polish",
      "review": "Dr. Mutha and team are genuinely the best cleaning & polish option near Thakurli. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "tooth-extraction-kalyan": [
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Tooth extraction",
      "review": "Honestly the best tooth extraction I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Tooth extraction",
      "review": "Came in for tooth extraction after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Tooth extraction",
      "review": "Dr. Mutha and team are genuinely the best tooth extraction option near Kalyan East. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dental-x-ray-opg-kalyan": [
    {
      "name": "Meera Bhatia",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Digital OPG",
      "review": "Honestly the best digital opg I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Priya Sharma",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Digital OPG",
      "review": "Came in for digital opg after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Vikram Joshi",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Digital OPG",
      "review": "Dr. Mutha and team are genuinely the best digital opg option near Ambernath. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dental-veneers-kalyan": [
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Porcelain veneers",
      "review": "Honestly the best porcelain veneers I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Porcelain veneers",
      "review": "Came in for porcelain veneers after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Porcelain veneers",
      "review": "Dr. Mutha and team are genuinely the best porcelain veneers option near Kalyan East. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "smile-design-kalyan": [
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Smile design",
      "review": "Honestly the best smile design I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Smile design",
      "review": "Came in for smile design after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan East."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Smile design",
      "review": "Dr. Mutha and team are genuinely the best smile design option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "teeth-whitening-cost-kalyan": [
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Teeth whitening",
      "review": "Honestly the best teeth whitening I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Teeth whitening",
      "review": "Came in for teeth whitening after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan East."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Teeth whitening",
      "review": "Dr. Mutha and team are genuinely the best teeth whitening option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dental-crowns-bridges-kalyan": [
    {
      "name": "Kavita Iyer",
      "location": "Ulhasnagar",
      "rating": 5,
      "treatment": "Crowns & bridges",
      "review": "Honestly the best crowns & bridges I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Arjun Rao",
      "location": "Dombivli East",
      "rating": 5,
      "treatment": "Crowns & bridges",
      "review": "Came in for crowns & bridges after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Dombivli East."
    },
    {
      "name": "Rahul Mehta",
      "location": "Dombivli",
      "rating": 5,
      "treatment": "Crowns & bridges",
      "review": "Dr. Mutha and team are genuinely the best crowns & bridges option near Dombivli. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "root-canal-treatment-kalyan": [
    {
      "name": "Amit Patil",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Root canal",
      "review": "Honestly the best root canal I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Anjali Nair",
      "location": "Diva",
      "rating": 5,
      "treatment": "Root canal",
      "review": "Came in for root canal after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Diva."
    },
    {
      "name": "Sandeep Gupta",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Root canal",
      "review": "Dr. Mutha and team are genuinely the best root canal option near Thakurli. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dental-implants-cost-kalyan": [
    {
      "name": "Vikram Joshi",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Dental implant",
      "review": "Honestly the best dental implant I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Meera Bhatia",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Dental implant",
      "review": "Came in for dental implant after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Khadakpada."
    },
    {
      "name": "Priya Sharma",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Dental implant",
      "review": "Dr. Mutha and team are genuinely the best dental implant option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "all-on-4-implants-kalyan": [
    {
      "name": "Sandeep Gupta",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "All-on-4 implants",
      "review": "Honestly the best all-on-4 implants I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Amit Patil",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "All-on-4 implants",
      "review": "Came in for all-on-4 implants after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Khadakpada."
    },
    {
      "name": "Anjali Nair",
      "location": "Diva",
      "rating": 5,
      "treatment": "All-on-4 implants",
      "review": "Dr. Mutha and team are genuinely the best all-on-4 implants option near Diva. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "braces-treatment-kalyan": [
    {
      "name": "Suresh Pawar",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Metal braces",
      "review": "Honestly the best metal braces I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Divya Menon",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Metal braces",
      "review": "Came in for metal braces after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Ambernath."
    },
    {
      "name": "Neha Desai",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Metal braces",
      "review": "Dr. Mutha and team are genuinely the best metal braces option near Thakurli. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "clear-aligners-kalyan": [
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Clear aligners",
      "review": "Honestly the best clear aligners I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Clear aligners",
      "review": "Came in for clear aligners after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Clear aligners",
      "review": "Dr. Mutha and team are genuinely the best clear aligners option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "invisalign-cost-kalyan": [
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Invisalign",
      "review": "Honestly the best invisalign I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Invisalign",
      "review": "Came in for invisalign after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan East."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Invisalign",
      "review": "Dr. Mutha and team are genuinely the best invisalign option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "pediatric-dentist-kalyan": [
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Kids dental visit",
      "review": "Honestly the best kids dental visit I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Kids dental visit",
      "review": "Came in for kids dental visit after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan East."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Kids dental visit",
      "review": "Dr. Mutha and team are genuinely the best kids dental visit option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "gum-disease-treatment-kalyan": [
    {
      "name": "Sandeep Gupta",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Gum treatment",
      "review": "Honestly the best gum treatment I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Amit Patil",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Gum treatment",
      "review": "Came in for gum treatment after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Khadakpada."
    },
    {
      "name": "Anjali Nair",
      "location": "Diva",
      "rating": 5,
      "treatment": "Gum treatment",
      "review": "Dr. Mutha and team are genuinely the best gum treatment option near Diva. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "emergency-dentist-kalyan": [
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Emergency visit",
      "review": "Honestly the best emergency visit I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Emergency visit",
      "review": "Came in for emergency visit after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Emergency visit",
      "review": "Dr. Mutha and team are genuinely the best emergency visit option near Kalyan East. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dentist-kalyan-west": [
    {
      "name": "Suresh Pawar",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Honestly the best dental check-up I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Divya Menon",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Came in for dental check-up after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Ambernath."
    },
    {
      "name": "Neha Desai",
      "location": "Thakurli",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Dr. Mutha and team are genuinely the best dental check-up option near Thakurli. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dentist-kalyan-east": [
    {
      "name": "Sneha Kulkarni",
      "location": "Kalyan East",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Honestly the best dental check-up I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Rohan Shah",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Came in for dental check-up after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Kalyan."
    },
    {
      "name": "Pooja Singh",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Dr. Mutha and team are genuinely the best dental check-up option near Kalyan. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ],
  "dentist-near-kalyan-station": [
    {
      "name": "Priya Sharma",
      "location": "Kalyan",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Honestly the best dental check-up I've found in Kalyan. The team explained every step before they started and there was zero pain. So glad I didn't travel to Mumbai."
    },
    {
      "name": "Vikram Joshi",
      "location": "Ambernath",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Came in for dental check-up after reading the reviews and they fully lived up to it. Friendly staff, clean clinic, fair pricing. Recommending Mutha's Advanced Dental Care to my whole family in Ambernath."
    },
    {
      "name": "Meera Bhatia",
      "location": "Khadakpada",
      "rating": 5,
      "treatment": "Dental check-up",
      "review": "Dr. Mutha and team are genuinely the best dental check-up option near Khadakpada. The follow-up care after my treatment was top notch. Five stars from me."
    }
  ]
};

export const getTestimonialsForSlug = (slug: string): ServiceTestimonial[] =>
  TESTIMONIALS[slug] ?? [];
